var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quill-editor',{staticClass:"py-2",attrs:{"content":_vm.value,"options":_vm.editorOption},on:{"change":function($event){return _vm.onChange($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }